export default __webpack_public_path__ + "static/media/card4.a8f3ef13.svg";